export default __webpack_public_path__ + "static/media/service-bg.dfdeffd8.webp";